module.exports = __webpack_public_path__ + "img/marypop-mg.18ed178a.png";